import React, { useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Breadcrumb, Button, Confirm } from 'semantic-ui-react'
import { titleCase } from 'change-case'
import { MainBodyContent } from 'components'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import GeneralInformation from '../Form/GeneralInformation'
import BankGuaranteeInformation from '../Form/BankGuaranteeInformation'
import VendorContact from '../Form/VendorContact'
import Attachment from '../Form/Attachment'
import Approve from '../Form/Approve'
import CommentHistory from 'routes/BankGuarantee/Form/CommentHistory'
import DocumentStep from 'routes/ProcurementSystem/Shared/DocumentStep'
import { bgVendorRequestPath } from 'routes'
import { DocumentTypeContent } from './styled'
import { updateBGRequest, getBGRequestDetail, deleteBGRequest, getWorkflow } from 'ducks/bankGuaranteeRequest'
import { validateRequestForm } from '../../../helper'
import { getVendors, getCompanies } from 'ducks/options'
import { StatusTag } from '../../../styled'

const EditBankGuaranteeRequest = (props) => {
  const { valueForm, change, vendorOptions, companyOptions, bgRequest, workflow } = props
  const [mainFormClickSave, setMainFormClickSave] = useState(false)
  const [submit, setSubmit] = useState(false)
  const [showConfirmDelete, setShowConfirmDelete] = useState(false)

  React.useEffect(() => {
    const id = props.match.params.id || ''
    props.getBGRequestDetail(id)
    props.getWorkflow(id)

    if (!vendorOptions.data.length && !vendorOptions.loading) {
      props.getVendors()
    }

    if (!companyOptions.data.length && !companyOptions.loading) {
      props.getCompanies()
    }
  }, [])

  const onSubmitEditForm = (values) => {
    if (mainFormClickSave) {
      const { updateBGRequest, history } = props

      var errors = validateRequestForm(values)

      if (Object.keys(errors).length) {
        scrollToFirstValidateFailElement(errors)
        setMainFormClickSave(false)
        throw new SubmissionError(errors)
      } else {
        setMainFormClickSave(false)
        updateBGRequest(values, submit, history)
      }
    }
  }
  
  return (
    <MainBodyContent 
      headerTitle={
        <React.Fragment>
          {`Request Bank Guarantee - ${valueForm.documentNumber || 'Edit'}`}
          <StatusTag status={valueForm.status} style={{ marginLeft: '10px' }}>{valueForm.statusName}</StatusTag>
        </React.Fragment>
      }
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'BG', content: 'Request Change/Return', link: true, onClick: () => props.history.push(bgVendorRequestPath) },
              { key: 'BGEdit', content: 'Edit Request', active: true }
            ]
          }
        />
      }
      accessoriesHeader= {
        <div className='cardHeaderActions'>
        </div>
      }
    >
      {
        valueForm.status ? <DocumentStep documentDetail={bgRequest} approvers={workflow.data} /> : null
      }
      <form onSubmit={props.handleSubmit((values) => onSubmitEditForm(values))}>
        <DocumentTypeContent>Request for : {titleCase(valueForm.requestType)}</DocumentTypeContent>
        <BankGuaranteeInformation valueForm={valueForm} change={change} />
        <GeneralInformation valueForm={valueForm} change={change} />
        <Approve handleSubmit={props.handleSubmit} history={props.history} />
        <VendorContact change={change} formName='formBGRequest' />
        <Attachment valueForm={valueForm} change={change} />
        {
          valueForm.status ? <CommentHistory comments={valueForm.comments} attachment={valueForm.attachment03} /> : null
        }
        {
          (valueForm.creator === props.username && valueForm.status === 0) ?
          <React.Fragment>
            {
              valueForm.status === 0 ?
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                <div>
                  {valueForm.status === 0 ?
                    <Button
                      type='button'
                      content='Delete'
                      color='red'
                      icon='trash'
                      labelPosition='right'
                      onClick={() => setShowConfirmDelete(true)}
                    /> : null}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                  <Button
                    type='submit'
                    content='Save'
                    icon='save'
                    labelPosition='right'
                    style={{ marginRight: '5px' }}
                    onClick={() => {
                      setMainFormClickSave(true)
                      setSubmit(false)
                    }}
                  />
                  <Button
                    type='submit'
                    content='Save & Submit'
                    color='blue'
                    icon='save'
                    labelPosition='right'
                    style={{ marginRight: '5px' }}
                    onClick={() => {
                      setMainFormClickSave(true)
                      setSubmit(true)
                    }}
                  />
                </div>
              </div> : null
            }
          </React.Fragment> : null
          
        }
      </form>
      <Confirm
        open={showConfirmDelete}
        header='Delete Bank Guarantee Request'
        content='Are you sure to delete this document?'
        confirmButton='Delete'
        onCancel={() => setShowConfirmDelete(false)}
        onConfirm={() => {
          props.deleteBGRequest(valueForm.id, props.history)
          setShowConfirmDelete(false)
        }}
      />
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const user = state.authen.user || {}
  const username = user.username || ''
  const vf = getFormValues('formBGRequest')(state) || {}

  return ({
    user,
    username,
    valueForm: vf,
    vendorOptions: state.options.vendors,
    companyOptions: state.options.companies,
    bgRequest: state.bgRequest.bgRequest.data,
    workflow: state.bgRequest.workflow,
    initialValues: {
      ...state.bgRequest.bgRequest.data
    },
  })
}

const mapDispatchToProps = {
  updateBGRequest, 
  getBGRequestDetail,
  getVendors, 
  getCompanies,
  deleteBGRequest,
  getWorkflow,
}

const validate = (values) => {
  let errors = validateRequestForm(values)

  return errors
}

const EditBankGuaranteeRequestForm = reduxForm({
  form: 'formBGRequest',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(EditBankGuaranteeRequest)

export default connect(mapStateToProps, mapDispatchToProps)(EditBankGuaranteeRequestForm)
